import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import Bulmatown from "bulmatown"
import "./visits.js"
import "./features.js"
import "./story_link.js"
import "./http_panels.js"
import "./candid_panels.js"
import "./system_info.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
